import { render } from "./InputHealthChart.vue?vue&type=template&id=8400a8da"
import script from "./InputHealthChart.vue?vue&type=script&lang=js"
export * from "./InputHealthChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/InputHealthChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8400a8da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8400a8da', __exports__)) {
    api.reload('8400a8da', __exports__)
  }
  
  module.hot.accept("./InputHealthChart.vue?vue&type=template&id=8400a8da", () => {
    api.rerender('8400a8da', render)
  })

}


export default __exports__